import { escape, raw, type Html } from "../html.ts";

const KEYWORDS = new Set(["import", "from", "export", "function", "const", "let", "return", "async", "await", "if", "else", "type", "interface"]);

/**
 * A small TypeScript line highlighter for code views. Emits the design's code classes (k keyword, s string, f function,
 * n number, c comment). Not a parser; good enough for diffs and file views.
 */
export function highlightLine(line: string): Html {
  const out: string[] = [];
  const re = /(\/\/.*$)|("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'|`(?:[^`\\]|\\.)*`)|(\b\d[\d_.]*\b)|([A-Za-z_$][\w$]*)(?=\s*\()|([A-Za-z_$][\w$]*)|(\s+|.)/g;
  for (const m of line.matchAll(re)) {
    const [text = "", comment, str, num, fn, word] = m;
    const e = escape(text);
    if (comment) out.push(`<span class="c">${e}</span>`);
    else if (str) out.push(`<span class="s">${e}</span>`);
    else if (num) out.push(`<span class="n">${e}</span>`);
    else if (fn) out.push(KEYWORDS.has(text) ? `<span class="k">${e}</span>` : `<span class="f">${e}</span>`);
    else if (word && KEYWORDS.has(text)) out.push(`<span class="k">${e}</span>`);
    else out.push(e);
  }
  return raw(out.join(""));
}
